
export class ExpressionTypes {
    static readonly Const = "Const";
    static readonly Var = "Var";
    static readonly Object = "Object";
    static readonly Collection = "Collection";
    static readonly ObjectMap = "ObjectMap";
    static readonly CollectionMap = "CollectionMap";
    static readonly StringTemplate = "StringTemplate";
    static readonly ContentTemplate = "Content_Template";
}
